import './login.css';

import React, { useRef, useState } from 'react';

import EnglishResourceBundle from './locale/login.en.json'
import FrenchResourceBundle from './locale/login.fr.json'
import { SelectLanguage } from '../../Components'
import { authenticationService } from '../../Services';
import { history } from '../../Helpers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import { Link } from 'react-router-dom';












export const Login = (props) => {    
    let formElement = useRef(null);

    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'login', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'login', FrenchResourceBundle);

    const { email } = useParams();
    const [state, setState] = useState({
        username: email || "",
        password: "",
        disabled: false,
        errors: {
            username: "",
            password: "",
            api: ""
        }
    });

    if (authenticationService.currentUserValue) {
        history.push('/');
    }

    const onChange = (e) => {
        const newState = {...state};
        newState[e.target.name] = e.target.value;
        setState(newState);
    }

    const onSubmit = (e) => {        
        e.preventDefault();
        setState({...state, disabled: true});
        authenticationService.login(state.username, state.password)
            .then(
                user => {
                    const { from } = props.location.state || { from: { pathname: "/" } };
                    history.push(from);
                    history.replace(from.pathname);
                },
                error => {
                    const newState = {...state};
                    newState.disabled = false;
                    newState.errors.api = error ? error : t("login:errorMessage");
                    setState(newState);                    
                }
            )
    }

    return (
        <div className="wrapper">
            <img src={require("./img/bg.jpg")} alt="" className="bg" />
            <div className="login-form">
                <div className="row">
                    <div className="col col-left">
                        <form noValidate onSubmit={onSubmit} ref={formElement}>                                
                            <div className="row">
                                <div className="col">
                                    <img src={require("./img/avancie.png")} alt="Avancie" />
                                </div>
                                <div className="col text-right"><SelectLanguage></SelectLanguage></div>
                            </div>
                            <h4 className="modal-title">{t("login:title")}</h4>

                            <div className="form-group">
                                <input 
                                    type="text"
                                    name="username"
                                    value={state.username}
                                    onChange={onChange}
                                    placeholder={t("login:email")} 
                                    className={'form-control' + (state.errors.username.length > 0 ? ' is-invalid' : '')}
                                    required="required" />                            
                            </div>
                            <div className="form-group">
                                <input 
                                    type="password"
                                    name="password" 
                                    value={state.password}
                                    onChange={onChange}
                                    placeholder={t("login:passwordOrKey")} 
                                    className={'form-control' + (state.errors.username.length > 0 ? ' is-invalid' : '')} 
                                    required="required" />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-primary btn-lg" disabled={state.disabled}>{t("login:signIn")}</button>
                                {state.disabled &&
                                    <img alt="Loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }
                            </div>
                            {state.errors.api.length > 0 && 
                                <div className="alert alert-danger" role="alert">
                                    {state.errors.api}
                                </div>
                            }
                            {/* <br />
                            <br />
                            <div>Vous n'avez pas encore de compte ?  <a href="/#">Créez un compte</a></div>
                            <br />
                            <div><a href="/#">Mot de passe oublié ?</a></div> */}
                        </form>
                    </div>
                    <div className="col col-right">
                        <div className="welcome">
                            <h1>aform</h1>
                            <h2>{t("login:yourForms")}</h2>
                            <h3>{t("login:yourFormsSubtitle")}</h3>
                        </div>
                        <div className="triangle-bottomleft"></div>
                        <div className="triangle-left"></div>
                        <div className="triangle-bottomright"></div>
                        <div className="welcome-footer">
                            <ul className="list-inline">
                                <li><a href={t("login:personalInformationHref")} target="_blank" rel="noopener noreferrer">{t("login:personalInformation")}</a></li>
                                {/* <li><Link to="/about">{t("login:aboutUs")}</Link></li>
                                <li><Link to="/conditions-of-use">{t("login:terms")}</Link></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
